import {computed,observable,runInAction,autorun} from 'mobx';
import {observer} from 'mobx-react';
import InputModel from '../models/InputModel'
import SelectionModel from '../models/SelectionModel'
import CommonEntriesStore from './CommonEntriesStore'
import BaseEntriesStore from './BaseEntriesStore'
import OutputModel from '../models/OutputModel'
import PrintOutput from "../models/PrintOutput";
import Utils from "../utils/Utils"


class BrespaAnalyseStore extends CommonEntriesStore{
    constructor(){
        super();
        this.basenentries = BaseEntriesStore

    }
    basenentries = BaseEntriesStore;
    title = "Einzelpositionen";
    @observable plattendicke = new InputModel('Plattendicke',20,'cm',true,false);

    plattenoptions = [
        {title:'A20B',value:20},
        {title:'A20Q',value:20}
    ];
    //überschriebene entries
    @observable lohnkosten = new InputModel('Lohnkosten',1,'');
    @observable baustahlpreisStab = new InputModel('Baustahlpreis für Stabstahl',1,'');
    @observable baustahlpreisMatten = new InputModel('Baustahlpreis für Stahlmatten',1 ,'');
    @observable mietpreis = new InputModel('Mietkosten',1,'');
    @observable bewehrung_einbauen = new InputModel('Bewehrung BSt-Matten einbauen',1,'');
    @observable betonieren_transportbeton = new InputModel('Betonieren Transportbeton',1,'');
    @observable ruestzeiten_pumpe = new InputModel('Rüstzeiten Autobetonpumpe',1,'');
    @observable oberflaeche_abziehen = new InputModel('Oberfläche abziehen/glätten',1,'');
    @observable aussparungen_einbauen = new InputModel('Aussparungen ein- und ausbauen',1,'');
    @observable kosten_stuetzung = new InputModel('Kosten für zus. Stützung',1,'');
    //-----



    @observable brespaselection = new SelectionModel("Erf. Dicke <strong>BRESPA®</strong>-Decken",SelectionModel.createOptionsFromObjectArray(this.plattenoptions),0);
    @observable montagezeit = new InputModel('Montagezeit/Element',1,'');
    @observable personal_montage = new InputModel('Personal Montag',1,'');
    @observable krankosten = new InputModel('Krankosten',1,'');
    @observable spachteln_streichen = new InputModel('Spachteln / Streichen',1,'');
    @observable zusatzartikel = new InputModel('Zusatzartikel',1,'');
   //@observable randschalung = 0;

    @computed get totalDickeBrespa1(){
        return new PrintOutput("Erforderliche Dicke BRESPA®-Decke + "+this.brespaselection.selectedOption.title,"" , Utils.rAndF(this.plattendicke.value),"cm",false,"","")
    }
    @computed get totalKostenStützung(){
        var out = new OutputModel("Mehrkosten für zusätzlich <br/>erforderliche Deckenauflager","Mehrkosten für zusätzlich <br/>erforderliche Deckenauflager",0.0,'€/m²');
        return out;
    }
    @computed get totalValueBrespa(){
        var out =  new OutputModel("Gesamtkosten für " + this.plattendicke.value +' cm Decke',"Gesamtkosten für" + this.plattendicke.value +' cm Decke',0.0,'€/m²');
        return out;
    }

    @computed get totalDicke(){
        var out = new OutputModel("Erforderliche Dicke","Erforderliche Dicke",this.plattendicke.value,'cm');
        return out;
    }
    @computed get randschalung(){
        let k = this.lohnkosten ;
        return  new InputModel("lfd. m <br/>Randschalung <br/>(20 bis 32 cm)",0.45 * this.lohnkosten.value +5 ,''+k.einheit);
    }

    @computed get max_laenge_other(){
        console.log("plattendicke", this.plattendicke.value)
        let ml = Math.sqrt(150*(this.plattendicke.value-2.5)/100);
        console.log("ML bei plattendicke",ml, this.plattendicke.value)
        return this.round(ml,1);
    }

    updateData = autorun(() => {
        if(!this.basenentries || !this.basenentries.eingabefelder.brespa){return}
        let daten = this.basenentries.daten
        this.brespaselection.setOptions(SelectionModel.createOptionsFromObjectArray(daten.brespaplatten),0);
        let felder = this.basenentries.eingabefelder.brespa;
        if(!felder){return}

        for (let key in felder) {
            if( this.hasOwnProperty( key ) ) {
                //console.log("setting: ", key)
                runInAction(() => {
                    this[key].value = felder[key].value;
                    this[key].einheit = felder[key].einheit;
                    this[key].disabled = !felder[key].editable;
                    this[key].title = felder[key].title;
                });

            }
        };
        this.entries.push(this.entries.pop())
        let felder_nefd = this.basenentries.eingabefelder.brespa_nefd;
        if(!felder_nefd){return}

        for (let key in felder_nefd) {
            if( this.hasOwnProperty( key ) ) {
                //console.log("setting: ", key)
                runInAction(() => {
                    this[key].value = felder_nefd[key].value;
                    this[key].einheit = felder_nefd[key].einheit;
                    this[key].disabled = !felder_nefd[key].editable;
                    this[key].title = felder_nefd[key].title;
                    this[key].isText = true;
                });

            }
        };
        this.entries.push(this.entries.pop())

    },{delay:200});


    /*
    *   Maßgebende Stützweite:

        Erforderliche Plattendicke:

        Gewählter Plattentyp:
        Gewählte Plattendicke:
        Preis FreiBau:
        Größennachlass:
        Zusatzartikel:
        Randschalung:
        Erforderliche Bewehrung:
        Kosten Randschalung:
        Vergussbeton:

        Kosten Beton:
        Unteseitenbehandlung:
        Montage:
        Anzahl Platten:
        Montagezeit:
        Kosten Montage Mann:
        Kosten Kran:
        Verguss- und Bewehrungszeit:
        Verguss/Bewehrungs kosten Mann:
        Vergusskosten Kran/Pumpe:

    * */

    /*get print_montagekosten(){
        return "___€/h  x ___h = ___€";
    }
    get print_stahlbewehrung(){
        return "___kg/m² x ___m² = ___€";
    }
    get print_betonanker(){
        return "___€/m² x ___m² =___€";
    }
    get print_randschalung(){
        return "___€/lfd. m x ___m = ___€";
    }
    get print_montagedeckenelement(){
        return "___Min./St x ___St =___Min.";
    }
    get print_ringerfugen(){
        return "___Min.";
    }
    get print_krankosten(){
        return "___€/h x ___h =___€";
    }
    get print_endbehandlungunten(){
        return "___€/m² x ___m² =___€";
    }
    get print_preisbaustelle(){
        return "(___km) ___€/m² x  ___ m² =__€";
    }
    get print_herstellungskostenqm(){
        return " ___ cm , Typ A___= ___€";
    }
    get print_herstellungskostengesamt(){
        return "___ cm , Typ A___= ___€";
    }
    get print_dauerherstellung(){
        return "___h";
    }*/

    print_montagekosten = new PrintOutput();
    print_stahlbewehrung = new PrintOutput();
    print_betonanker = null;
    print_randschalung = null;
    print_montagedeckenelement = null;
    print_ringerfugen = null;
    print_krankosten = null;
    print_endbehandlungunten = null;
    print_preisbaustelle = null;
    print_herstellungskostenqm = null;
    print_herstellungskostengesamt = null;
    print_dauerherstellung = null;

    print_zeit_total = 0;
    print_material_total = 0;

    calckosten = autorun(() => {
        this.print_zeit_total = 0;
        this.print_material_total = 0;
        //Maßgebende Stützweite:
        if(!this.basenentries.daten.stuetzweiten){return}
        var maxsw = Math.max(this.basenentries.stuetzweiteb1.value, this.basenentries.stuetzweiteb2.value);
        if(this.basenentries.strukturAuswahl.selectedOption.value.type == "ef"){
            maxsw = this.basenentries.stuetzweiteb1.value;
        }

        let minplattendicken = this.basenentries.daten.stuetzweiten.filter(sw => sw.weite >= maxsw ).sort(function(a, b) {
            return a.weite - b.weite;
        });
        console.log("minplattendicken",minplattendicken);
        let minplattendicke = minplattendicken[0].decke;
        if(this.plattendicke.value !== minplattendicke){

            this.plattendicke.value = minplattendicke;
        }

        this.basenentries.dicke_erforderlich_brespa.value = minplattendicke;

        if(this.brespaselection.selectedOption.value !== minplattendicke || this.brespaselection.options.length > 1 ){
            this.brespaselection.setOptions(SelectionModel.createOptionsFromObjectArray([this.basenentries.daten.brespaplatten.filter(p=> p.value >= minplattendicke)[0]]),0)

        }
        let seldicke = this.plattendicke.value;

        let entf = this.basenentries.entfernung.value;
        let platte = this.brespaselection.selectedOption.title;
        let entfpreis = this.basenentries.daten.entfernungen.filter(e => e.entfernung >= entf ).sort((a, b) => a.entfernung - b.entfernung);

        let preisfreibau = entfpreis.length >0 ? entfpreis[0][platte] : this.basenentries.daten.entfernungen[0][platte];
        let deckenfl = this.basenentries.deckenflaeche.value;
        let garr = this.basenentries.daten.groessennachlass.filter(e => deckenfl >= e.qm  )
        let groessennachlass = garr.sort((a, b) => b.qm - a.qm  )[0][platte];
        let zusatzartikel = this.zusatzartikel.value;
        let randschalung_meter = this.basenentries.anzahldecken.value* (this.basenentries.geblaenge.value+this.basenentries.gebbreite.value)*2;

        let erfbewehrung = this.basenentries.baustahlpreisStab.value *2.5
        let kostenrandschalung = randschalung_meter * this.basenentries.randschalung_eingabe.value / deckenfl
        this.print_randschalung = new PrintOutput(Utils.rAndF(randschalung_meter)+" m",this.basenentries.randschalung_eingabe.getCombinedVal(), Utils.rAndF(kostenrandschalung*deckenfl),"€");
        this.print_material_total += kostenrandschalung*deckenfl;
        let vergussbeton = deckenfl*5*minplattendicke/10000+0.35*deckenfl*minplattendicke/1000
        let kostenbeton = vergussbeton * this.basenentries.betonpreis.value / deckenfl
        this.print_betonanker = new PrintOutput(Utils.rAndF(kostenbeton)+" €/m²",Utils.rAndFNoDec(deckenfl)+" m²",Utils.rAndF(kostenbeton*deckenfl),"€")
        this.print_material_total += kostenbeton*deckenfl;
        let unterseite = this.spachteln_streichen.value
        let anzahlplatten = Math.ceil(deckenfl/((this.basenentries.stuetzweiteb1.value +  this.basenentries.stuetzweiteb2.value)/2*1.2)*1.05)
        let montage_zeit = anzahlplatten * this.montagezeit.value/60
        this.print_montagedeckenelement = new PrintOutput("","",Utils.rAndF(this.montagezeit.value)+" min/St. x "+ Utils.rAndFNoDec(anzahlplatten)+" St = "+Utils.rAndF((this.montagezeit.value)*anzahlplatten/60)+" h","",true);
        let kosten_montage_mann = montage_zeit *this.personal_montage.value* this.lohnkosten.value/deckenfl
        let kosten_krahn = (montage_zeit + 2) * this.krankosten.value / deckenfl
        let vergusszeit = montage_zeit * 0.8;
        this.print_ringerfugen = new PrintOutput("","",Utils.rAndF(((this.montagezeit.value*anzahlplatten)*0.8)/60.0)+" h","",true);
        let bewehrungskosten = vergusszeit * this.personal_montage.value *this.lohnkosten.value/deckenfl
        let tpkost = ((kosten_montage_mann + bewehrungskosten) * deckenfl)/this.lohnkosten.value;
        this.print_montagekosten = new PrintOutput(this.lohnkosten.getCombinedVal(),Utils.rAndF(tpkost),Utils.rAndF(tpkost*this.lohnkosten.value),"€");
        this.print_zeit_total = (montage_zeit+vergusszeit)*4;

        this.print_stahlbewehrung = new PrintOutput(Utils.rAndF(erfbewehrung) + " €/m²",Utils.rAndFNoDec(deckenfl)+" m²",Utils.rAndF(erfbewehrung*deckenfl),"€");
        this.print_material_total += erfbewehrung*deckenfl;
        //let vergusskosten = vergusszeit * this.basenentries.betonpreis.value / deckenfl
        let vergusskosten_kran = vergusszeit * this.krankosten.value / deckenfl
        this.print_krankosten = new PrintOutput(Utils.rAndF((vergusszeit + montage_zeit + 2))+" h",this.krankosten.getCombinedVal(), Utils.rAndF((this.krankosten.value * (vergusszeit + montage_zeit + 2))) , "€");
        this.print_endbehandlungunten = new PrintOutput(Utils.rAndF(unterseite)+" €/m²",Utils.rAndFNoDec(deckenfl)+" m²",Utils.rAndF(unterseite*deckenfl),"€")
        this.print_preisbaustelle = new PrintOutput( Utils.rAndF((preisfreibau + groessennachlass + zusatzartikel)) +" €/m²",Utils.rAndFNoDec(deckenfl)+" m²",Utils.rAndF((preisfreibau + groessennachlass + zusatzartikel) *deckenfl),"€")
       this.print_material_total += (preisfreibau + groessennachlass + zusatzartikel) *deckenfl
        this.print_dauerherstellung = new PrintOutput("","",(montage_zeit+vergusszeit)+" h","",true)
        let total = preisfreibau + groessennachlass + zusatzartikel + erfbewehrung + kostenrandschalung + kostenbeton +
            unterseite+ kosten_montage_mann + kosten_krahn + bewehrungskosten  + vergusskosten_kran;

        if(this.totalValue.value !== total){
            this.totalValue.value = total;
        }
            this.totalValueBrespa.value = total;
        this.totalKostenStuetzung.value = 0;
        this.totalValueBrespaStuetzung.value = total;
        if(this.randschalung != kostenrandschalung){

           // this.randschalung = kostenrandschalung;
        }
        //console.group()
        console.groupCollapsed("Brespa Kosten:::::::::::")
        console.log("addieren von:");
        console.log("preisfreibau: " , preisfreibau)
        console.log("groessennachlass: " , groessennachlass)
        console.log("zusatzartikel: " , zusatzartikel)
        console.log("erfbewehrung: " , erfbewehrung)
        console.log("kostenrandschalung: " , kostenrandschalung)
        console.log("kostenbeton: " , kostenbeton);
        console.log("unterseite: " , unterseite);
        console.log("kosten_montage_mann: " , kosten_montage_mann);
        console.log("kosten_krahn: " , kosten_krahn);
        console.log("bewehrungskosten: " , bewehrungskosten);
       // console.log("vergusskosten: " , vergusskosten);
        console.log("vergusskosten_kran: " , vergusskosten_kran);
        console.log("----------------")
        console.log("total:",total)
        console.groupEnd()
    },{delay:200});

    nfdentries = [

        this.basenentries.baustahlpreisStab,
        this.baustahlpreisMatten,
        this.basenentries.betonpreis,
        this.mietpreis,
        this.bewehrung_einbauen,
        this.betonieren_transportbeton,
        this.ruestzeiten_pumpe,

        this.aussparungen_einbauen,
        this.kosten_stuetzung,
        this.basenentries.randschalung
    ];


    @observable entries = [
        this.lohnkosten,
        this.basenentries.baustahlpreisStab,
        this.baustahlpreisMatten,
        this.basenentries.betonpreis,
       // this.mietpreis,
        this.bewehrung_einbauen,
        this.betonieren_transportbeton,
        this.ruestzeiten_pumpe,
        this.oberflaeche_abziehen,
        this.aussparungen_einbauen,
        this.kosten_stuetzung,
       // this.basenentries.randschalung,
        //this.plattendicke,
        //this.brespaselection,


    ];
    @observable stahl_eingebaut = new InputModel('Stahl eingebaut',"enthalten","€/kg",true,false,null,true);
    @observable decke_abladen = new InputModel('Elementdeckenplatten <br/>abladen bis verlegen',"enthalten","h/St.",true,false,null,true);
    @observable joche_stellen = new InputModel('Joche stellen <br/>und ausbauen',"nicht erf.","h/St.",true,false,null,true);
    @observable entries2 = [
        this.montagezeit,
        this.personal_montage,
        this.stahl_eingebaut,
        this.decke_abladen,
        this.joche_stellen,
        this.krankosten,
        this.spachteln_streichen
    ];

}
export default new BrespaAnalyseStore();




// WEBPACK FOOTER //
// ./src/stores/BrespaAnalyseStore.js